(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* TR-WOS: in-stock-only toggle pill */
  (function(){
    const STORAGE_KEY = 'tr_in_stock_only';
    function initToggle(){
      const btn = document.querySelector('[data-tr-stock-toggle]');
      const list = document.querySelector('results-list');
      if(!btn || !list || btn.dataset.trBound === '1') return;
      btn.dataset.trBound = '1';
      const apply = (on) => {
        list.classList.toggle('tr-in-stock-only', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('tr-stock-toggle--active', on);
      };
      try { apply(localStorage.getItem(STORAGE_KEY) === '1'); } catch(e){}
      btn.addEventListener('click', () => {
        const next = btn.getAttribute('aria-pressed') !== 'true';
        apply(next);
        try { localStorage.setItem(STORAGE_KEY, next ? '1' : '0'); } catch(e){}
      });
    }
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', initToggle);
    } else { initToggle(); }
    document.addEventListener('shopify:section:load', initToggle);
  })();

  } catch(e) { console.error(e); }
})();
})();
